import { createElement, useCallback, useEffect, useRef, useState, type ReactElement } from "react";

/** 2.6秒（長い文は最大8秒まで延長）で消えるトースト。`toastNode` を GiftingPage の末尾に1つ置く。 */
export function useGfToast(): { toast: (msg: string) => void; toastNode: ReactElement | null } {
  const [message, setMessage] = useState("");
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  const toast = useCallback((msg: string) => {
    if (timer.current) clearTimeout(timer.current);
    setMessage(msg);
    timer.current = setTimeout(() => setMessage(""), Math.min(8000, 2600 + Math.max(0, msg.length - 24) * 110));
  }, []);

  const toastNode = message ? createElement("div", { className: "gf-toast", role: "status" }, message) : null;
  return { toast, toastNode };
}
